/**
 * Device 도메인 Query Hook Wrapper
 */

import {useQuery, useQueryClient} from '@tanstack/react-query';
import {useCallback} from 'react';
import {DEVICE_QUERY_KEY_MAP} from '../api/device/constant';
import {deviceFactory} from '../factory/deviceFactory';

// ============================================
// useAppConfigQuery
// ============================================

export function useAppConfigQuery(
  ...args: Parameters<typeof deviceFactory.appConfig>
) {
  return useQuery(deviceFactory.appConfig(...args));
}

useAppConfigQuery.getKey = (
  ...args: Parameters<typeof DEVICE_QUERY_KEY_MAP.appConfig>
) => [...DEVICE_QUERY_KEY_MAP.appConfig(...args)];

// ============================================
// useDeviceInfoQuery
// ============================================

export function useDeviceInfoQuery(
  ...args: Parameters<typeof deviceFactory.deviceInfo>
) {
  const queryClient = useQueryClient();
  const result = useQuery(deviceFactory.deviceInfo(...args));

  const refetch = useCallback(() => {
    return queryClient.invalidateQueries({
      queryKey: DEVICE_QUERY_KEY_MAP.deviceInfo,
    });
  }, [queryClient]);

  return {...result, refetch};
}

useDeviceInfoQuery.getKey = () => [...DEVICE_QUERY_KEY_MAP.deviceInfo];
